import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseNavComponent } from '../base-nav.component';

import { LanguageTempComponent } from '../../language-switcher/components/language-temp/language-temp.component';
import { PermissionEnum } from '@core/permissions/permission.enum';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { PermittedDirective } from '@core/permissions/permitted.directive';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'stx-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatToolbar,
    MatToolbarRow,
    RouterLink,
    MatMenuItem,
    RouterLinkActive,
    PermittedDirective,
    MatButton,
    MatTooltip,
    MatIcon,
    MatMenuTrigger,
    MatMenu,
    MatDivider,
    LanguageTempComponent,
    TranslateModule
  ]
})
export class NavBarComponent extends BaseNavComponent implements OnInit {
  routerLink: string = '/';
  isAccountMenuOpened: boolean = false;
  isToolTipDisabled: boolean = false;
  @ViewChild('tooltipSpanElement', { static: false }) tooltipSpanElement: ElementRef<HTMLSpanElement>;

  ngOnInit() {
    this.subSink.sink = this.currentUserService.user$.subscribe(user => {
      if (user) {
        this.getNavItems();
      }
    });
  }

  updateToolTipVisibility(): void {
    this.isToolTipDisabled = !this.tooltipSpanElement.nativeElement.style.display;
  }

  get canSeeEditSettingsRoute(): boolean {
    return this.authService.checkUserPermission(PermissionEnum.EDIT_USER_SETTINGS);
  }

  switchProfile(): void {
    this.router.navigateByUrl('/select-profile');
  }
}
